import $ from "jquery"

$(document).ready(function () {
    let isHittaDiariet = document.getElementById("hitta-diariet") != null;

    if (isHittaDiariet) {

        const searchCasesButton = document.getElementsByClassName('search-cases-btn')[0];
        const searchEventButton = document.getElementsByClassName('search-event-btn')[0];

        searchCasesButton.addEventListener('focus', function (e) {
            e.preventDefault();

            searchEventButton.classList.remove('selected-form');
            searchCasesButton.classList.add('selected-form');
        });

        searchEventButton.addEventListener('focus', function (e) {
            e.preventDefault();

            searchCasesButton.classList.remove('selected-form');
            searchEventButton.classList.add('selected-form');
        })

        // Reset case-form
        function resetCasesForm(event) {
            event.preventDefault();

            let casesForm = document.getElementById("search-cases-form");
            let formElements = casesForm.elements;

            for (let i = 0; i < formElements.length; i++) {
                let element = formElements[i];

                if (element.tagName === 'INPUT' || element.tagName === 'SELECT' || element.tagName === 'TEXTAREA') {

                    element.value = '';
                }
            }

            window.location.search = "?subtype=Ärende";
        }
        let resetCasesBtn = document.getElementById("cases-reset-button");
        resetCasesBtn.addEventListener("click", resetCasesForm);

        // Reset event-form
        function resetEventForm(event) {
            event.preventDefault();

            let eventForm = document.getElementById("search-event-form");
            let formElements = eventForm.elements;

            for (let i = 0; i < formElements.length; i++) {
                let element = formElements[i];

                if (element.tagName === 'INPUT' || element.tagName === 'SELECT' || element.tagName === 'TEXTAREA') {
                    element.value = '';
                }
            }

            window.location.search = "?subtype=Händelse";
        }
        let resetEventBtn = document.getElementById("event-reset-button");
        resetEventBtn.addEventListener("click", resetEventForm);

        ////// Show Case type and unit only if management has been selected on case form.
        const selectManagement = document.getElementById("select-managementCase");
        const selectCasetypeUnit = document.getElementById("select-casetype-unit");
        function handleManagementChange() {

            const isAllDiarierSelected = selectManagement.value === "";

            selectCasetypeUnit.classList.toggle('showSelect', !isAllDiarierSelected);

            populateCaseTypesBasedOnmanagement(selectManagement.value, 'selectCaseType');
            populateUnitBasedOnmanagement(selectManagement.value, 'selectCaseForm');
        }

        selectManagement.addEventListener("change", handleManagementChange);
        document.addEventListener("DOMContentLoaded", function () {
            if (selectManagement.value !== "") {
                handleManagementChange();
            }
        });

        // Show Actiontype and unit only if management has been selected on event form.
        const selectManagementEventform = document.getElementById("select-management-eventform");
        const selectCasetypeUnitEventform = document.getElementById("select-actiontype-unit-eventform");
        function handleSelectManagementChange() {
            const isAllDiarierSelected = selectManagementEventform.value === "";

            selectCasetypeUnitEventform.classList.toggle('showSelect', !isAllDiarierSelected);

            populateCaseTypesBasedOnmanagement(selectManagementEventform.value, 'selectActionTypeEventForm');
            populateUnitBasedOnmanagement(selectManagementEventform.value, 'selectEventForm');
        }
        selectManagementEventform.addEventListener("change", handleSelectManagementChange);
        document.addEventListener("DOMContentLoaded", handleSelectManagementChange);

        async function populateCaseTypesBasedOnmanagement(value, formId) {
            const response = await fetch("/HittaSearchDiariet/FetchFacetsFromSearchEngineAsync?diarie_namn=" + value);
            let facets = await response.json();
            let selectCaseType = document.getElementById("select-case-type");
            let selectCaseTypeLabel = document.querySelector('label[for="select-case-type"]');
            let selectActionTypeEventForm = document.getElementById("select-actiontype-eventform");
            let selectActionTypeEventFormLabel = document.querySelector('label[for="select-actiontype-eventform"]');

            let select = selectCaseType;
            if (formId === 'selectActionTypeEventForm') {
                select = selectActionTypeEventForm;
            }

            select.innerHTML = '';
            select.style.display = "block";
            selectCaseTypeLabel.style.display = "block";
            selectActionTypeEventFormLabel.style.display = "block";

            let allOption = document.createElement("option");
            allOption.text = "Alla";
            allOption.value = "";
            select.appendChild(allOption);

            const index = facets.findIndex(x => x.id === "diarie_typ");

            if (index !== -1) {
                const filteredFacet = facets[index];
                if (filteredFacet !== null) {
                    filteredFacet.filters.forEach(item => {
                        let option = document.createElement("option");
                        option.text = item.displayName;
                        let extractedValue = null;

                        for (let part of item.query.split('&')) {
                            let parts = part.split('=');
                            if (parts[0] === "diarie_typ") {
                                extractedValue = parts[1];
                            }
                        }

                        option.value = extractedValue;
                        if (item.selected) {
                            option.selected = true;
                        }
                        select.appendChild(option);

                    });
                }
            }
        }

        async function populateUnitBasedOnmanagement(value, formId) {
            const response = await fetch("/HittaSearchDiariet/FetchFacetsFromSearchEngineAsync?diarie_namn=" + value);
            let facets = await response.json();
            let selectCaseForm = document.getElementById("select-unit-typeCase");
            let selectCaseFormLabel = document.querySelector('label[for="select-unit-typeCase"]');
            let selectEventForm = document.getElementById("select-unit-type-eventform");
            let selectEventFormLabel = document.querySelector('label[for="select-unit-type-eventform"]');

            let selectElement = selectCaseForm;
            if (formId === 'selectEventForm') {
                selectElement = selectEventForm;
            }

            selectElement.innerHTML = '';
            selectElement.style.display = "block";
            selectCaseFormLabel.style.display = "block";
            selectEventFormLabel.style.display = "block";

            let allOption = document.createElement("option");
            allOption.text = "Alla";
            allOption.value = "";
            selectElement.appendChild(allOption);

            const index = facets.findIndex(x => x.id === "diarie_enhet");

            if (index !== -1) {
                const filteredFacet = facets[index];
                if (filteredFacet !== null) {
                    filteredFacet.filters.forEach(item => {
                        let option = document.createElement("option");
                        option.text = item.displayName;
                        let extractedValue = null;

                        for (let part of item.query.split('&')) {
                            let parts = part.split('=');
                            if (parts[0] === "diarie_enhet") {
                                extractedValue = parts[1];
                            }
                        }

                        option.value = extractedValue;

                        if (item.selected) {
                            option.selected = true;
                        }
                        selectElement.appendChild(option);
                    });
                }
            }
        }

        const filterWrapper = document.getElementById("diarie-result-filter");
        filterWrapper?.addEventListener("change", handleSelectManagementChangeSearch)

        async function handleSelectManagementChangeSearch() {
            window.location.search = "?" + filterWrapper.value;
        }
    }
});